"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItem = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_responsive_1 = tslib_1.__importDefault(require("react-responsive"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var constants_1 = require("../../constants");
exports.ListItem = function (_a) {
    var isActive = _a.isSelected, className = _a.className, children = _a.children, restProps = tslib_1.__rest(_a, ["isSelected", "className", "children"]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("button", tslib_1.__assign({ className: classnames_1.default("gd-list-item", "gd-filter-list-item", {
                "is-selected": isActive,
                "gd-filter-list-item-selected": isActive,
            }, className) }, restProps),
            children,
            isActive && (react_1.default.createElement(react_responsive_1.default, { query: constants_1.MediaQueries.IS_MOBILE_DEVICE },
                react_1.default.createElement(sdk_ui_kit_1.CustomizableCheckmark, { className: "gd-customizable-checkmark-mobile-date-filter" }))))));
};
//# sourceMappingURL=ListItem.js.map